"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CommonOptionCard = void 0;

var _commonOptionCard = _interopRequireDefault(require("./components/common-option-card"));

exports.CommonOptionCard = _commonOptionCard["default"];